import styled, { css } from "styled-components";
import { fontNormal, fontBold } from "../../_static/Typography";
import buildColor from "../../_static/ColorPalette";
import rainLayerUrl from "../../_static/images/rma-blue-texture.png";
import Button from "../../_atom/Buttons/button";

// Add vh to fix account registration
export const OuterContainer = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: ${buildColor("blue", "900")};

  @media only screen and (min-width: 768px) {
    padding-top: 50px;

    &::before {
      content: "";
      background-image: url(${rainLayerUrl});
      background-repeat: no-repeat;
      background-position-x: center;
      background-size: 1280px auto;
      top: 0;
      left: 0;
      bottom: 450px;
      right: 0;
      position: absolute;
      z-index: 1;
    }
  }
`;

export const InnerContainer = styled.div`
  z-index: 2;
  background-color: ${buildColor("white", "100")};
  display: flex;
  flex-direction: column;
  padding: ${({ isFullSsn, isSsn, isEditing }) =>
    isFullSsn || (isEditing && isSsn) ? "0 12px 12px 12px" : "12px"};

  @media only screen and (max-width: 767px) {
    z-index: 0;
    flex-grow: 1;
    margin-top: ${({ isEditing }) => (isEditing ? "46px" : "70px")};
    min-height: ${({ isEditing }) =>
      isEditing ? "calc(100vh - 46px)" : "calc(100vh - 70px)"};

    .desktop-message-box {
      display: none;
    }

    .mobile-message-box {
      display: block;
      width: calc(100% + 24px);
      margin-left: -12px;
    }
  }

  @media only screen and (min-width: 768px) {
    width: 480px;
    align-self: center;
    padding: 24px;
    border-radius: 2px;

    .desktop-message-box {
      display: block;
      margin: -24px -24px 0;
    }

    .mobile-message-box {
      display: none;
    }
  }
`;

export const MobilePageWrapper = styled.div`
  @media only screen and (max-width: 767px) {
    display: block;
  }
`;

export const InnerTitle = styled.h2`
  font-family: ${fontBold};
  font-weight: 700;
  font-size: 18px;
  margin-bottom: ${({ $isAutoAddressWithInfoText }) =>
    $isAutoAddressWithInfoText ? "8px" : "12px"};
  margin-top: ${({ isFullSsn, isSsn, isEditing }) =>
    isFullSsn || (isEditing && isSsn) ? "12px" : "0"};
`;

export const InfoTitle = styled.h3`
  font-size: 16px;
  font-weight: 500;
  font-family: ${({ isSsn }) => (isSsn ? `${fontBold}` : `${fontNormal}`)};
  line-height: 22px;
  color: ${buildColor("grey", "900")};

  @media only screen and (max-width: 767px) {
    margin-top: ${({ isFullSsn, isSsn }) =>
      isFullSsn || isSsn ? "12px" : "24px"};
  }
`;

export const InnerInfo = styled.p`
  font-size: 14px;
  font-weight: 400;
  font-family: ${fontNormal};
  color: ${buildColor("grey", "800")};
  margin-bottom: ${({ isFullSsn }) => (isFullSsn ? "0" : "12px")};
`;

export const MessageBoxContainer = styled.div`
  ${({ addBottomMargin }) =>
    addBottomMargin &&
    css`
      margin-bottom: 8px;
    `}
`;

export const SubmitButton = styled(Button)`
  ${({ showDisabled }) =>
    showDisabled &&
    css`
      opacity: 0.5;
    `}
`;
